const es = {
  header: {
    badge: "Guía Oficial de BotMix",
    title: "Publicaciones en Comunidades",
    summary:
      "Programa y automatiza publicaciones en canales y grupos de comunidades de WhatsApp de forma centralizada. Envía mensajes de texto, imágenes, videos y audios a múltiples comunidades con control horario.",
  },
  sections: [
    {
      id: "programacion_comunidades",
      title: "1. Programación y Difusión",
      description:
        "Configura publicaciones puntuales o recurrentes en tus comunidades de WhatsApp.",
      items: [
        {
          id: "seleccion_comunidades",
          title: "Comunidades y Subgrupos",
          definition:
            "Selecciona una o varias comunidades administradas para realizar envíos simultáneos a todos sus miembros.",
        },
        {
          id: "multimedia_ia",
          title: "Contenido Multimedia y Fábrica IA",
          definition:
            "Adjunta archivos desde el Administrador de Archivos o crea publicaciones con imágenes y videos generados con Inteligencia Artificial.",
        },
      ],
    },
    {
      id: "control_sincronizacion",
      title: "2. Conexiones y Sincronización",
      description:
        "Monitoreo de estado de conexiones y actualización de grupos de comunidad.",
      items: [
        {
          id: "sincronizar_comunidades",
          title: "Sincronización de Comunidades",
          definition:
            "Limpia y actualiza el listado de comunidades y subgrupos directamente desde tu sesión de WhatsApp activa.",
        },
        {
          id: "estado_publicaciones",
          title: "Monitoreo y Reenvío",
          definition:
            "Revisa el historial de publicaciones enviadas, pendientes o fallidas con posibilidad de edición y republicación rápida.",
        },
      ],
    },
  ],
};

const en = {
  header: {
    badge: "BotMix Official Guide",
    title: "Community Broadcasts",
    summary:
      "Schedule and automate broadcasts across WhatsApp communities and announcement channels. Deliver text, images, videos, and voice notes with flexible scheduling.",
  },
  sections: [
    {
      id: "programacion_comunidades",
      title: "1. Scheduling & Broadcasting",
      description:
        "Set up one-time or recurring publications across your WhatsApp communities.",
      items: [
        {
          id: "seleccion_comunidades",
          title: "Target Communities & Subgroups",
          definition:
            "Select one or multiple managed communities to broadcast announcements simultaneously.",
        },
        {
          id: "multimedia_ia",
          title: "Media Content & AI Studio",
          definition:
            "Attach media from File Manager or generate custom graphics and videos using AI Content Factory.",
        },
      ],
    },
    {
      id: "control_sincronizacion",
      title: "2. Connection & Sync",
      description:
        "Manage connection states and refresh active community channels.",
      items: [
        {
          id: "sincronizar_comunidades",
          title: "Community Sync",
          definition:
            "Refresh and clean your community group lists directly from your active WhatsApp device.",
        },
        {
          id: "estado_publicaciones",
          title: "Status Monitoring",
          definition:
            "Audit sent, pending, or failed broadcast schedules with quick re-scheduling and editing capabilities.",
        },
      ],
    },
  ],
};

const pt = {
  header: {
    badge: "Guia Oficial BotMix",
    title: "Publicações em Comunidades",
    summary:
      "Agende e automatize postagens em comunidades e canais do WhatsApp de forma unificada. Envie textos, imagens, vídeos e áudios com agendamento flexível.",
  },
  sections: [
    {
      id: "programacion_comunidades",
      title: "1. Agendamento e Disparos",
      description:
        "Configure publicações pontuais ou recorrentes para as suas comunidades.",
      items: [
        {
          id: "seleccion_comunidades",
          title: "Comunidades e Subgrupos",
          definition:
            "Selecione uma ou mais comunidades administradas para disparar anúncios simultâneos.",
        },
        {
          id: "multimedia_ia",
          title: "Mídias e Fábrica de IA",
          definition:
            "Envie arquivos do Gerenciador de Arquivos ou gere conteúdos multimídia profissionais com Inteligência Artificial.",
        },
      ],
    },
    {
      id: "control_sincronizacion",
      title: "2. Conexões e Sincronização",
      description:
        "Monitore o status das sessões e atualize canais de comunidade.",
      items: [
        {
          id: "sincronizar_comunidades",
          title: "Sincronização de Comunidades",
          definition:
            "Atualize a lista de grupos e comunidades diretamente do WhatsApp conectado.",
        },
        {
          id: "estado_publicaciones",
          title: "Histórico e Monitoramento",
          definition:
            "Acompanhe publicações agendadas, concluídas ou com falha com edição rápida.",
        },
      ],
    },
  ],
};

const fr = {
  header: {
    badge: "Guide Officiel BotMix",
    title: "Diffusions dans les Communautés",
    summary:
      "Planifiez et automatisez des publications dans les communautés WhatsApp. Diffusez des textes, images, vidéos et notes vocales avec planification horaire précise.",
  },
  sections: [
    {
      id: "programacion_comunidades",
      title: "1. Planification et Diffusion",
      description:
        "Configurez des envois ponctuels ou récurrents vers vos communautés WhatsApp.",
      items: [
        {
          id: "seleccion_comunidades",
          title: "Communautés et Sous-groupes",
          definition:
            "Sélectionnez une ou plusieurs communautés gérées pour diffuser des messages simultanément.",
        },
        {
          id: "multimedia_ia",
          title: "Multimédia et Studio IA",
          definition:
            "Joignez des fichiers multimédias ou concevez des contenus avec l'Intelligence Artificielle.",
        },
      ],
    },
    {
      id: "control_sincronizacion",
      title: "2. Connexions et Synchronisation",
      description:
        "Surveillez les connexions WhatsApp et synchronisez vos communautés.",
      items: [
        {
          id: "sincronizar_comunidades",
          title: "Synchronisation des Communautés",
          definition:
            "Actualisez et nettoyez vos listes de communautés directement depuis votre WhatsApp actif.",
        },
        {
          id: "estado_publicaciones",
          title: "Suivi des Publications",
          definition:
            "Consultez l'historique des publications envoyées ou en attente avec réédition rapide.",
        },
      ],
    },
  ],
};

const ar = {
  header: {
    badge: "دليل BotMix الرسمي",
    title: "النشر في مجتمعات واتساب",
    summary:
      "جدولة وأتمتة النشر عبر مجتمعات وقنوات واتساب بشكل مركزي. أرسل الرسائل النصية والصور والفيديوهات والتسجيلات الصوتية بمرونة تامة.",
  },
  sections: [
    {
      id: "programacion_comunidades",
      title: "1. الجدولة والبث",
      description:
        "إعداد المنشورات الفورية أو المجدولة عبر مجتمعات واتساب الخاصة بك.",
      items: [
        {
          id: "seleccion_comunidades",
          title: "المجتمعات والمجموعات التابعة",
          definition:
            "حدد مجتمعاً أو أكثر لنشر الإعلانات في وقت واحد لجميع الأعضاء.",
        },
        {
          id: "multimedia_ia",
          title: "الوسائط المتعددة واستوديو الذكاء الاصطناعي",
          definition:
            "أرفق الملفات أو صمم محتوى مرئي بواسطة استوديو الذكاء الاصطناعي.",
        },
      ],
    },
    {
      id: "control_sincronizacion",
      title: "2. الاتصال والمزامنة",
      description:
        "مراقبة حالة الجلسات وتحديث قائمة المجتمعات.",
      items: [
        {
          id: "sincronizar_comunidades",
          title: "مزامنة المجتمعات",
          definition:
            "تحديث قوائم المجتمعات والمجموعات مباشرة من تطبيق واتساب المتصل.",
        },
        {
          id: "estado_publicaciones",
          title: "مراقبة المنشورات",
          definition:
            "مراجعة المنشورات المرسلة والمعلقة مع إمكانية التعديل وإعادة الجدولة.",
        },
      ],
    },
  ],
};

export const COMMUNITY_HELP_DATA = { es, en, pt, fr, ar };
export default COMMUNITY_HELP_DATA;
